import Vue from "vue";

Vue.directive("optix-currency", function (el, binding, vnode) {
  if (vnode.context && vnode.context.$optix && !isNaN(el.innerText)) {
    el.innerText = vnode.context.$optix.utils.currencyFormat(el.innerText);
  }
});
